import React, { useContext, useState } from "react";
//@ts-ignore
import { LocalizationContext } from "react-localize";
import "./CancelConfirmationModal.sass";
import { MvPrimaryBtn } from "Generic/MvPrimaryBtn";
import moment from "moment";
import { trackAnalyticData } from "Utils/analytics";

type Props = {
    openModal: boolean;
    toggleModal: () => void;
    onConfirmation: () => void;
    reservationDetails: any;
    reservationConfirmationNumber: string;
    id?: string
    scrollY?: boolean;
  };
  
  const CancelConfirmationModal = ({
    openModal,
    toggleModal,
    id,
    scrollY,
    reservationDetails,
    reservationConfirmationNumber,
    onConfirmation
  }: Props) => {
    const { localize } = useContext(LocalizationContext);
    const [submissionInProgress, setSubmissionInProgress] = useState(false);
    if (!openModal) {
        return <div />;
      }

      return (
          <React.Fragment>
              <section
                className={`${!openModal ? "cancel-confirm-main-overlay hide" : "cancel-confirm-main-overlay"} ${scrollY ? "scroll-y" : ""}`}
                id={id ? id : ""}
              >
                  <div className="content">
                    <div className="content-title">{localize("static.content.canceled-reservation-page-header")}</div>
                    <p className="content-sub-title">{reservationDetails.resortName || ""}</p>
                    <p className="content-location">{reservationDetails.resortLocation || ""}</p>
                    <div className="content-cancel">
                      <p className="content-cancel-heading">Cancel This Reservation</p>
                      <p className="content-text"><span>{reservationConfirmationNumber}</span> <span> {reservationDetails.checkInDate
                        ? moment(reservationDetails.checkInDate).format(
                            "MMM DD, YYYY"
                          )
                        : "-"}{" "}
                      -{" "}
                      {reservationDetails.checkOutDate
                        ? moment(reservationDetails.checkOutDate).format(
                            "MMM DD, YYYY"
                          )
                        : "-"}</span></p>
                      <p className="content-text">{localize("static.content.cancel-modal-warning-message")}</p>
                    </div>
                    <div className="content-footer">
                      <div className="content-footer-no">
                        <MvPrimaryBtn
                            isDisabled={false}
                            submissionInProgress={false}
                            text={'No'}
                            onClick={() => { toggleModal(); trackAnalyticData('cancelNo'); }}
                        />
                      </div>
                      <div className="content-footer-yes">
                        <MvPrimaryBtn
                            isDisabled={submissionInProgress}
                            submissionInProgress={submissionInProgress}
                            text={'Yes'}
                            onClick={() => { setSubmissionInProgress(true); onConfirmation(); trackAnalyticData('cancelYes'); }}
                        />
                      </div>
                    </div>
                  </div>
              </section>
              <div
                className={!openModal ? "cancel-confirm-black-overlay hide" : "cancel-confirm-black-overlay"}
                onClick={toggleModal}
              >
              </div>
          </React.Fragment>
      )
  }

  export default CancelConfirmationModal;